import React from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const PersonalityDevelopment = () => {
  const studentList = [
    {
      itemCode: "S001",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S002",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S003",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S004",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S005",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S006",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S007",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
    {
      itemCode: "S008",
      name: "Jahiruddin Chowdhury",
      studentId: "#SM0523019",
      class: "5/A",
      reportingTo: "Touhid Hassan",
      contact: "9876543210",
    },
  ];

  const studentTableHeaders = [
    { key: "name", label: "Name" },
    { key: "class", label: "Class" },
    { key: "reportingTo", label: "Reporting to" },
    { key: "contact", label: "Contact" },
  ];

  const eventHistoryData = [
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Training for upgradation of skills",
      students: [
        {
          name: "1. Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 18000,
        },
        {
          name: "2. Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 0,
        },
        {
          name: "3. Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 0,
        },
      ],
      totalAmount: 18000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      vendor: {
        name: "Muklesur coaching",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Training for upgradation of skills",
      students: [
        {
          name: "Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 18000,
        },
      ],
      totalAmount: 36000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Training for upgradation of skills",
      students: [
        {
          name: "Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 18000,
        },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Training for upgradation of skills",
      students: [
        {
          name: "Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 18000,
        },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Training for upgradation of skills",
      students: [
        {
          name: "Jahiruddin Chowdhury",
          neededFor: "Training for upgradation of skills",
          amount: 18000,
        },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: null,
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
  ];

  const columns = [
    {
      label: "Receipt id/Time",
      key: "receiptId",
      render: (row) => (
        <>
          {row.receiptId}
          <br />
          <span style={{ color: "var(--orangeColor)", fontSize: "small" }}>
            {row.time}
          </span>
        </>
      ),
    },
    {
      label: "Student name",
      key: "name",
      render: (row) =>
        row.students.map((student, i) => <div key={i}>{student.name}</div>),
    },
    {
      label: "Needed For",
      key: "neededFor",
      render: (row) =>
        row.students.map((student, i) => (
          <div key={i}>{student.neededFor}</div>
        )),
    },
    {
      label: "Total bill (INR)",
      key: "amount",
      render: (row) => (
        <>
          {row.students.map((student, i) => (
            <div key={i}>
              ₹ {Number(student.amount).toLocaleString("en-IN")}
            </div>
          ))}
          <div style={{ borderTop: "1px solid black", marginTop: "4px" }}>
            Total:{" "}
            <span style={{ color: "var(--blueColor1)" }}>
              ₹ {Number(row.totalAmount).toLocaleString("en-IN")}
            </span>
          </div>
        </>
      ),
    },
    {
      label: "Paid amount (INR)",
      key: "paidAmount",
      render: (row) => (
        <>
          ₹ {Number(row.paidAmount).toLocaleString("en-IN")}
          <br />
          <span style={{ color: "var(--deepGreen3)", fontSize: "small" }}>
            {row.paymentMethod}
          </span>
        </>
      ),
    },
    {
      label: "Mentor/event",
      key: "vendor",
      render: (row) => (
        <>
          {row.vendor.name}
          <br />
          Ph:{" "}
          <span style={{ color: "var(--blueColor1)" }}>{row.vendor.phone}</span>
        </>
      ),
    },
    {
      label: "Confirmed by",
      key: "confirmedBy",
      render: (row) => (
        <span style={{ color: "var(--deepGreen3)" }}>{row.confirmedBy}</span>
      ),
    },
    {
      label: "Receipts",
      key: "receipts",
      render: (row) => (
        <>
          <span
            style={{
              color: "var(--blueColor1)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
            }}
          >
            Receipt <BsBoxArrowRight />
          </span>
          <br />
          <button
            className="action-pay-btn"
            style={{
              backgroundColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
              borderColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
            }}
          >
            {row.paidAmount < row.totalAmount ? "Pay due" : "All paid"}
          </button>
        </>
      ),
    },
  ];

  // Sample dropdown data
  const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
  const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];
  const _this = {
    studentList,
    studentTableHeaders,
    eventHistoryData,
    columns,
    confirmedByOptions,
    paymentModes,
  };
  return <Body {..._this} />;
};

export default PersonalityDevelopment;
